"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelToModelInfoMap = exports.LanguageCodeToPhoneSetMap = exports.PhoneSetToLanguageCodeMap = void 0;
const language_code_1 = require("../entities/language-code");
const phone_set_1 = require("../entities/phone-set");
exports.PhoneSetToLanguageCodeMap = {
    cmu69: { language: language_code_1.LanguageCode.en },
    'novo-ar38': { language: language_code_1.LanguageCode.ar_idn },
    'novo-ar37': { language: language_code_1.LanguageCode.ar_idn },
    'novo-nl37': { language: language_code_1.LanguageCode.nl },
    'novo-cmn111': { language: language_code_1.LanguageCode.zh },
    'novo-fr37': { language: language_code_1.LanguageCode.fr },
    'novo-fr-nl61': { language: language_code_1.LanguageCode.fr },
    'novo-de45': { language: language_code_1.LanguageCode.de },
    'novo-es27': { language: language_code_1.LanguageCode.es },
};
exports.LanguageCodeToPhoneSetMap = {
    'ar-idn': { phoneSet: phone_set_1.PhoneSet.novo_ar38 },
    de: { phoneSet: phone_set_1.PhoneSet.novo_de45 },
    en: { phoneSet: phone_set_1.PhoneSet.cmu69 },
    nl: { phoneSet: phone_set_1.PhoneSet.novo_nl37 },
    zh: { phoneSet: phone_set_1.PhoneSet.novo_cmn111 },
    fr: { phoneSet: phone_set_1.PhoneSet.novo_fr37 },
    es: { phoneSet: phone_set_1.PhoneSet.novo_es27 },
};
exports.ModelToModelInfoMap = {
    'ar-2023-1': { phoneSet: phone_set_1.PhoneSet.novo_ar38, language: language_code_1.LanguageCode.ar_idn },
    'ar-2024-1': { phoneSet: phone_set_1.PhoneSet.novo_ar38, language: language_code_1.LanguageCode.ar_idn },
    'ar-2024-2': { phoneSet: phone_set_1.PhoneSet.novo_ar37, language: language_code_1.LanguageCode.ar_idn },
    'fr-2023-1': { phoneSet: phone_set_1.PhoneSet.novo_fr37, language: language_code_1.LanguageCode.fr },
    'fr-2024-1': { phoneSet: phone_set_1.PhoneSet.novo_fr_nl61, language: language_code_1.LanguageCode.fr },
};
//# sourceMappingURL=phone-set.mapper.js.map